export type AdminStatusTone =
  | "success"
  | "danger"
  | "error"
  | "pending"
  | "draft"
  | "processing"
  | "delivered"
  | "warning";

/** Order status → shared status tone (1 PROCESSING … 7 READY). */
export function orderStatusTone(status: number): AdminStatusTone {
  if(status === 1 || status === 7) return "processing";
  if(status === 2) return "pending";
  if(status === 3) return "delivered";
  if(status === 5) return "success";
  if(status === 4 || status === 6) return "danger";
  return "draft";
}

/** @deprecated Prefer orderStatusTone + AdminStatusBadge */
export function orderStatusBadgeVariant(status: number): "warning" | "success" | "danger" | "default" {
  const tone = orderStatusTone(status);
  if(tone === "success" || tone === "delivered") return "success";
  if(tone === "danger" || tone === "error") return "danger";
  if(tone === "processing" || tone === "pending" || tone === "warning") return "warning";
  return "default";
}

export function statusToneFromVariant(
  variant: "default" | "secondary" | "success" | "warning" | "danger" | "outline" | "pending" | "draft" | "processing" | "delivered"
): AdminStatusTone {
  if(variant === "success") return "success";
  if(variant === "danger") return "danger";
  if(variant === "warning") return "warning";
  if(variant === "pending") return "pending";
  if(variant === "processing") return "processing";
  if(variant === "delivered") return "delivered";
  if(variant === "draft" || variant === "secondary" || variant === "outline" || variant === "default") return "draft";
  return "draft";
}
